import {
	IconAdd,
	IconDelete,
	IconExport,
	IconFilter,
	IconSave,
} from "components/icons";
import React from "react";
import classNames from "utils/classNames";

const Button = ({
	type = "submit",
	className = "",
	children,
	kind,
	...rest
}) => {
	let defaultClassName =
		"text-white flex items-center justify-center gap-x-12px h-40px transition-all hover:brightness-90 w-fit text-base rounded-md px-3 lg:px-5 ml-auto ";
	let child = children;
	switch (kind) {
		case "add":
			defaultClassName = defaultClassName + "btn bg-blue-2";
			child = !children ? (
				<>
					<IconAdd></IconAdd>
					{"Thêm mới"}
				</>
			) : (
				children
			);
			break;
		case "addSecond":
			defaultClassName = defaultClassName + "bg-blue-3 btn btn-action";
			child = !children &&  (
				<>
					<IconAdd></IconAdd>
					{"Thêm mới"}
				</>
			);
			break;
		case "export":
			defaultClassName = defaultClassName + "bg-green-1 btn btn-export";
			child = !children &&  (
				<>
					<IconExport></IconExport>
					{"Xuất file"}
				</>
			);
			break;
		case "delete":
			defaultClassName = defaultClassName + "bg-gray-1 btn btn-delelte";
			child = !children &&  (
				<>
					<IconDelete></IconDelete>
					{"Xóa"}
				</>
			);
			break;
		case "filter":
			defaultClassName =
				defaultClassName +
				"btn btn-action btn-save mr-auto lg:mr-0 bg-blue-2 lg:!w-fit !w-full";
			child = !children &&  (
				<>
					<IconFilter></IconFilter>
					{"Lọc"}
				</>
			);
			break;
		case "saveAndClose":
			defaultClassName = defaultClassName + "btn btn-action btn-save";
			child = !children &&  (
				<>
					<IconSave></IconSave>
					<span>{"Lưu và đóng"}</span>
				</>
			);
			break;
		case "confirmNoDelete":
			defaultClassName = defaultClassName + "btn btn-action bg-primary";
			child = !children ?  (
				<>
					<span>{"Không"}</span>
				</>
			) : children;
			break;
		case "confirmYesDelete":
			defaultClassName = defaultClassName + "btn btn-action bg-blue-2";
			child = !children ?  (
				<>
					<span>{"Đồng ý"}</span>
				</>
			) : children;
			break;
		default:
			break;
	}
	return (
		<button
			type={type}
			className={classNames("", defaultClassName, className)}
			{...rest}>
			{child}
		</button>
	);
};

export default Button;
